import { useSiteContext, useTranslation } from '@eti/providers';
import * as allProducts from '../../products';
import { getCoverGeniusTranslations, productData } from '../utils';
const {
  BANKRUPTCY_INSURANCE_COVER_GENIUS,
  CANCELLATION_INSURANCE_COVER_GENIUS,
  COMPREHENSIVE_INSURANCE_COVER_GENIUS,
  TRAVEL_INSURANCE_COVER_GENIUS
} = allProducts;
export const useGetData = (products, numberOfTravelers) => {
  const {
    t
  } = useTranslation();
  const {
    market
  } = useSiteContext();
  const isInUSMarket = market.code === 'US';
  const isInUKMarket = market.code === 'GB';
  return products === null || products === void 0 ? void 0 : products.map(product => {
    const code = Object.values(allProducts).find(allProduct => {
      var _allProduct$id;
      return (allProduct === null || allProduct === void 0 || (_allProduct$id = allProduct.id) === null || _allProduct$id === void 0 ? void 0 : _allProduct$id.toString()) === product.id;
    });
    const codeName = (code === null || code === void 0 ? void 0 : code.name) || '';
    switch (product.id) {
      case BANKRUPTCY_INSURANCE_COVER_GENIUS.id.toString():
      case CANCELLATION_INSURANCE_COVER_GENIUS.id.toString():
      case COMPREHENSIVE_INSURANCE_COVER_GENIUS.id.toString():
      case TRAVEL_INSURANCE_COVER_GENIUS.id.toString():
        return {
          ...getCoverGeniusTranslations(product, t, codeName, isInUKMarket, isInUSMarket),
          ...productData(product, numberOfTravelers)
        };
      default:
        {
          return {
            productTitle: t(`${codeName}Title`),
            productDescription: t(`${codeName}Abstract`),
            productReadMore: t(`${codeName}ReadMoreModalContent`) || t(`${codeName}AdditionalSalesText`),
            ...productData(product, numberOfTravelers)
          };
        }
    }
  });
};
//# sourceMappingURL=useGetData.js.map